<template>

    <b-row class="inicio-sesion vh-100" align-h="center">
            <b-col cols="12" class="col-center inicio-sesion-content-logo" lg="12">
                <img class="inicio-sesion-logo" src="@/assets/logo.svg" alt="Logo Img">
            </b-col>
            <b-col cols="12" class="col-center" lg="12">
                <p class="inicio-sesion-titulo" v-html="content.titulo"></p>
            </b-col>
            <b-col v-if='olvido' cols="12" lg="4">
            </b-col>
            <b-col v-if='olvido' cols="12" class="col-center" lg="4">
                <p class="inicio-sesion-subtitulo" v-html="content.subtitulo"></p>
                <p class="inicio-sesion-content" v-html="content.content"></p>
            </b-col>
            <b-col v-if='olvido' cols="12" lg="4">
            </b-col>
            <b-col cols="12" lg="4">
            </b-col>
            <b-col cols="12" lg="4" class="mt-4 inicio-sesion-content-form">
                <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                    <b-form-group id="form-login-email" v-if='!olvido'>
                        <img src="@/assets/icons/user.png" alt="User Icon">
                        <b-form-input
                                id="input-1"
                                v-model="form.email"
                                type="email"
                                required
                                placeholder="Usuario"
                                :state="true"
                                size="lg" trim
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group id="form-login-password" style="padding-top: 1.5rem" v-if='!olvido'>
                        <img src="@/assets/icons/lock.png" alt="Lock Icon">
                        <b-form-input
                                id="input-2"
                                v-model="form.password"
                                required
                                type="password"
                                placeholder="Contraseña"
                                size="lg"
                        ></b-form-input>
                    </b-form-group>
                    <b-col cols="12" class="col-center mt-5" lg="12" v-if='!olvido'>
                        <button type="submit" class="button-primary-global button-section-inicio">
                            <span class="button-text-global-normal-2">Iniciar Sesión</span>
                        </button>
                    </b-col>
                    <b-form-group id="form-login-password" style="padding-top: 1.5rem" v-if='olvido'>
                        <b-form-input
                                id="input-2"
                                v-model="form.email"
                                required
                                placeholder="Correo electrónico"
                                size="lg"
                        ></b-form-input>
                    </b-form-group>
                    <b-col cols="12" class="col-center mt-5" lg="12" v-if='olvido'>
                        <button type="submit" class="button-primary-global button-section-inicio"
                                id="button-section-inicio">
                            <span class="button-text-global-normal-2">Enviar</span>
                        </button>
                    </b-col>
                </b-form>
            </b-col>
            <b-col cols="12" lg="4">
            </b-col>
            <b-col v-if='!olvido' cols="12" class="col-center inicio-sesion-content-olvide" lg="12">
                <p class="link-white cursor-pointer" @click="olvidoContrasena()">Olvidé mi contraseña</p>
            </b-col>
            <b-col cols="12" class="col-center inicio-sesion-content-volver" lg="12">
                <p class="link-white cursor-pointer" @click="goRouter('/')">Volver al inicio</p>
            </b-col>
            <b-col v-if='olvido' cols="12" class="col-center inicio-sesion-content-volver" lg="12">
                <p class="link-white cursor-pointer" @click="olvidoContrasena()">Regresar</p>
            </b-col>
    </b-row>
</template>
<script>
    export default {
        name: 'section-inicio',
        components: {},
        props: {
            content: Object
        },
        computed: {},
        data() {
            return {
                olvido: false,
                form: {
                    email: '',
                    password: '',
                },
                show: true
            }
        },
        methods: {
            olvidoContrasena() {
                this.olvido = !this.olvido
            },
            onSubmit(evt) {
                evt.preventDefault()
//                alert(JSON.stringify(this.form))
                if (!this.olvido) {
                    this.$store.dispatch('login', this.form)
                        .then(() => {
                            alert('Bienvenido a GOX')
                        })
                        .catch(() => {
                            alert('Datos Errados')
//                        this.$router.push('/')
                        })
                } else {
                    let form = {
                        'email': this.form.email
                    }
                    this.$store.dispatch('recoverPassword', form)
                        .then(() => {
                            alert('Revise su corre electronico, le fue enviado un email para restablecer la contrasena')
                        })
                        .catch(() => {
                            // console.log('error recoverPassword', error)
                        })
                }

            },
            onReset(evt) {
                evt.preventDefault()
                this.form.mensaje = ''
                this.show = false
                this.$nextTick(() => {
                    this.show = true
                })
            },
            goRouter(url) {
                this.$router.push(url)
            }
        }
    }
</script>
<style scoped>
</style>